import GenericTabComponent from "../../components/GenericTabComponent";
import About from "./Tabs/About";
import AdjacentPlacesOfAttraction from "./Tabs/AdjacentPlacesOfAttraction";
import ContactDetails from "./Tabs/ContactDetails";
import HowToReachRajgir from "./Tabs/HowToReachRajgir";
import LogoMascot from "./Tabs/LogoMascot";
import MatchFixtures from "./Tabs/MatchFixtures";
import TicketLink from "./Tabs/TicketLink";
import TournamnetSouvenirs from "./Tabs/TournamnetSouvenirs";
import TrophyTour from "./Tabs/TrophyTour";

export default function HeroAsiaCup2025() {
  const content = [
    { label: "About", component: <About /> },
    { label: "Mascot", component: <LogoMascot /> },
    // { label: "Trophy Tour", component: <TrophyTour /> },
    { label: "Match Fixtures", component: <MatchFixtures /> },
    { label: "How to reach Rajgir", component: <HowToReachRajgir /> },
    {
      label: "Nearby Tourist Sites",
      component: <AdjacentPlacesOfAttraction />,
    },
    // { label: "Souvenir", component: <TournamnetSouvenirs /> },
    // { label: "Book Your Pass", component: <TicketLink /> },
    // { label: "Contact Us", component: <ContactDetails /> },
  ];
  const pagetitle = "Men's Asia Hockey Cup 2025",
    // desktopBanner = "/img/HeroMensHockeyAsiaCup2025Rajgir/desktopBanner.jpg",
    desktopBanner = "https://biharsports.org/img/model-code-conduct/HeroMensHockeyAsiaCup2025Rajgir/desktopBanner.jpg",
    // mobileBanner = "/img/HeroMensHockeyAsiaCup2025Rajgir/mobileBanner.jpg";
    mobileBanner = "https://biharsports.org/img/model-code-conduct/HeroMensHockeyAsiaCup2025Rajgir/mobileBanner.jpg";
  return (
    <>
      <GenericTabComponent
        content={content}
        desktopBanner={desktopBanner}
        mobileBanner={mobileBanner}
        pageTitle={pagetitle}
      />
    </>
  );
}
